import { render, staticRenderFns } from "./TotalCommitment.vue?vue&type=template&id=33d115ea"
import script from "./TotalCommitment.vue?vue&type=script&lang=js"
export * from "./TotalCommitment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports